import React from 'react';
import Box from 'sail/Box';
import Grid, {GridItem} from 'sail/Grid';
import {BodyMono} from 'sail/Text';
import {CompactTooltip} from 'sail/Tooltip';

export const dimensions = {width: 328, height: 36};

// Contains column header for an input grid
export const HeaderBox = (props) => {
  const values = {
    style: {width: dimensions.width},
  };

  return <Box {...values}>{props.children}</Box>;
};

// Contains series of input rows, adds border
export const GridBox = (props) => {
  const values = {
    style: {width: dimensions.width * 2},
    divider: {side: 'all'},
  };

  return (
    <Box {...values}>
      <Grid gap={0}>{props.children}</Grid>
    </Box>
  );
};

// Contains label for an input row
export const LabelBox = (props) => {
  const values = {
    style: {...dimensions},
    divider: {side: 'bottom'},
    padding: {vertical: 8, horizontal: 16},
  };

  return (
    <Box {...values}>
      <BodyMono color={props.required ? 'default' : 'gray'}>
        {props.children}
      </BodyMono>
    </Box>
  );
};

// Represents an input row with a label and input component. Applies CompactTooltip to contents.
export const GridRow = (props) => {
  const labelContext = (
    <LabelBox required={props.required}>
      <label htmlFor={props.field_id}>{props.label}</label>
    </LabelBox>
  );

  const labelItem = (
    <GridItem columnSpan={6} row={props.row}>
      {props.description ? (
        <CompactTooltip
          context={labelContext}
          label={props.description}
          position="left"
          showDelay={800}
        />
      ) : (
        labelContext
      )}
    </GridItem>
  );
  const inputItem = (
    <GridItem column={7} columnSpan={6} row={props.row}>
      {props.description ? (
        <CompactTooltip
          context={props.children}
          aria-describedby={props.description}
          label={props.description}
          position="right"
          showDelay={800}
        />
      ) : (
        props.children
      )}
    </GridItem>
  );

  return (
    <>
      {labelItem}
      {inputItem}
    </>
  );
};
